import React from 'react'

function Pict() {
  return (
    <div className='pict' id='Pict'>
    <img src="/assets/bird.jpg" alt="" className='relative w-full h-fit' />
    <h2 className='bird absolute top-10 bg-light-300pict_name text-semibold  text-9xl text-white'>Paz Y Amor</h2>    
    </div>
  )
}

export default Pict